import { render, staticRenderFns } from "./location-detail-form.vue?vue&type=template&id=33359bd2"
import script from "./location-detail-form.vue?vue&type=script&lang=js"
export * from "./location-detail-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports